<template>
	<NuxtLink :to="props.item.url_without_domain" class="pp">
		<div class="pp-body">
			<div class="pp-image">
				<BaseUiImage :alt="item.main_image_description || item.title" :title="item.main_image_title" :data="item.main_image_thumbs?.['width790-height390-crop1']" default="/images/no-image-790.jpg" loading="lazy" />
			</div>
			<div class="pp-cnt">
				<div class="pp-title">{{item.title}}</div>
				<div class="pp-desc" v-if="item.short_description" v-html="stripHtml(item.short_description)"/>
			</div>
		</div>
	</NuxtLink>
</template>

<script setup>
const {stripHtml} = useText();
const props = defineProps({
	item: {
		type: Object,
		required: true
	}
})
</script>

<style scoped lang="less">
	.pp{
		display: block; text-decoration: none; color: var(--textColor); width: calc(~"50% - 32px"); text-align: center;
		&:hover{
			.pp-title{color: var(--blue);}
			.pp-image{
				:deep(img){box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.2);}
			}
		}
		@media (max-width: @l){width: calc(~"50% - 15px");}
		@media (max-width: @m){width: 100%;}
	}
	.pp-image{
		:deep(img){
			display: block; border-radius: 16px; box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.1); width: 100%; .transition(box-shadow);
			@media (max-width: @m){box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.08); border-radius: 10px;}	
		}
	}
	.pp-cnt{
		padding: 25px 7% 0;
		@media (max-width: @m){padding: 20px 8px 0;}	
	}
	.pp-title{
		font-size: 24px; line-height: 1.3;
		@media (max-width: @m){font-size: 18px;}	
	}
	.pp-desc{
		padding-top: 10px;
		@media (max-width: @m){font-size: 12px; padding-top: 6px;}	
	}

	.pp-featured{
		width: 100%; text-align: left; position: relative;
		&:before{.pseudo(auto,50px); bottom: -11px; left: 5%; right: 5%; background: var(--blue2); border-radius: 8px;}
		.pp-image{flex: 0 0 60%;}
		:deep(img){box-shadow: none;}
		.pp-title{font-size: 30px; line-height: 1.2;}
		.pp-body{display: flex; background: #fff; display: flex; padding: 24px; border-radius: 20px; box-shadow: 0px 15px 40px rgba(0, 0, 0, 0.1); align-items: center; position: relative; z-index: 1;}
		.pp-cnt{padding-inline: 6%;}
		@media (max-width: @l){
			.pp-title{font-size: 24px;}
		}
	}

	.pp-special{
		.pp-title{font-size: 20px;}
		.pp-cnt{padding-top: 18px;}
		@media (max-width: @m){
			.pp-title{font-size: 16px; line-height: 1.4;}
		}
	}
</style>